import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { vendorsApi, unwrapList } from "../api/resources";
import { useToast } from "../context/ToastContext";
import { useBuilderQuery } from "../hooks/useBuilderQuery";
import { useDebouncedValue } from "../hooks/useDebouncedValue";
import { Empty, Input, Loader, Pagination } from "../components/ui";
import { KhataSummary } from "../components/KhataSummary";
import { emptyKhata } from "../utils/finance";

export default function UdharVendors() {
  const { query, ready } = useBuilderQuery();
  const toast = useToast();
  const [items, setItems] = useState([]);
  const [pagination, setPagination] = useState({ page: 1, totalPages: 1 });
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");
  const liveSearch = useDebouncedValue(search);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    if (!ready) {
      setItems([]);
      setLoading(false);
      return;
    }
    setLoading(true);
    try {
      const data = unwrapList(await vendorsApi.udhar({ ...query, search: liveSearch, page, limit: 12 }));
      setItems(data.items);
      setPagination(data.pagination);
    } catch (error) {
      toast.error(error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, liveSearch, query.builderId]);

  useEffect(() => {
    setPage(1);
  }, [liveSearch]);

  return (
    <div className="stack">
      <header className="page-head">
        <div>
          <p className="eyebrow">Goods taken on credit</p>
          <h1>Credits</h1>
        </div>
      </header>

      <form className="filters" onSubmit={(event) => event.preventDefault()}>
        <Input value={search} onChange={(event) => setSearch(event.target.value)} placeholder="Search vendor" />
      </form>

      {loading ? (
        <Loader />
      ) : items.length === 0 ? (
        <Empty title="No credits due" text="Vendors you bought from on credit will show here." />
      ) : (
        <div className="sale-grid">
          {items.map((vendor) => {
            const khata = vendor.khata || emptyKhata();
            return (
              <article key={vendor.id} className="sale-card">
                <Link to={`/vendors/${vendor.id}/udhar`} className="sale-card-main">
                  <div className="sale-card-top">
                    <h3>{vendor.name}</h3>
                    <span className="pill pill-credit">Credit due</span>
                  </div>
                  <p>{vendor.phone || "No phone"}</p>
                  <KhataSummary khata={khata} variant="form" />
                </Link>
              </article>
            );
          })}
        </div>
      )}

      <Pagination page={pagination.page} totalPages={pagination.totalPages} onPage={setPage} />
    </div>
  );
}
